import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { FiUsers, FiShoppingBag, FiDollarSign, FiCheckCircle, FiClock, FiActivity } from 'react-icons/fi';

export default function AdminDashboard() {
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    api.get('/admin/stats').then((res) => setStats(res.data));
  }, []);

  if (!stats) return <div className="empty-state"><p>Loading...</p></div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700 }}>Admin Dashboard</h1>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiUsers /> Total Users</div>
          <div className="admin-stat-value">{stats.total_users}</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiShoppingBag /> Total Stores</div>
          <div className="admin-stat-value">{stats.total_stores}</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiCheckCircle /> Active Stores</div>
          <div className="admin-stat-value">{stats.active_stores}</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiDollarSign /> Total Revenue</div>
          <div className="admin-stat-value">{Number(stats.total_revenue).toFixed(3)} KD</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiActivity /> Paid Subscriptions</div>
          <div className="admin-stat-value">{stats.total_subscriptions}</div>
        </div>
        <div className="admin-stat-card">
          <div className="admin-stat-label"><FiClock /> Pending Payments</div>
          <div className="admin-stat-value">{stats.pending_payments}</div>
        </div>
      </div>

      <div className="card" style={{ padding: 20 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>Plans Breakdown</h3>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          {Object.entries(stats.plans_breakdown).map(([plan, count]) => (
            <div key={plan} style={{ textAlign: 'center', minWidth: 100 }}>
              <div style={{ fontSize: 32, fontWeight: 800, color: 'var(--secondary)' }}>{count as number}</div>
              <div style={{ fontSize: 13, color: 'var(--gray-500)', textTransform: 'capitalize' }}>{plan}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
